import React, { useMemo } from "react";
import { palette } from "lib/chartTheme";
import DistributionPie from "./DistributionPie";

const COLORS = [palette.deep, palette.sage, palette.gold, palette.sky];

const MaritalStatusChart = ({ data }) => {
  const slices = useMemo(
    () => [
      { label: "Married", value: data?.married },
      { label: "Single", value: data?.single },
      { label: "Divorced", value: data?.divorced },
      { label: "Widowed", value: data?.widowed },
    ],
    [data]
  );
  return <DistributionPie slices={slices} colors={COLORS} emptyText="No marital status data yet" />;
};

export default MaritalStatusChart;
